export default __webpack_public_path__ + "static/discover_logo-d3ae06a4f049ec16bc8b7cdcaa7ecdaf.png";